import { TemplatePageProps } from './types'
import { BubbleBuzzEntity } from './entity'
import Icon from 'images/games/bubble-buzz/icon.png'
import Swiper1 from 'images/games/bubble-buzz/swiper1.webp'
import Swiper2 from 'images/games/bubble-buzz/swiper2.webp'
import Swiper3 from 'images/games/bubble-buzz/swiper3.webp'
import Swiper4 from 'images/games/bubble-buzz/swiper4.webp'
import Swiper5 from 'images/games/bubble-buzz/swiper5.webp'
import Swiper6 from 'images/games/bubble-buzz/swiper6.webp'
import Swiper7 from 'images/games/bubble-buzz/swiper7.webp'
import Detail1 from 'images/games/bubble-buzz/detail1.png'
import Detail2 from 'images/games/bubble-buzz/detail2.png'
import Detail3 from 'images/games/bubble-buzz/detail3.png'
import Footer from 'images/games/bubble-buzz/footer.png'
import { BingoClashLink, EightBallStrikeLink, GamesLink, SolitaireClashLink } from '../../components'

export const BubbleBuzzDetail: TemplatePageProps = {
  entity: {
    ...BubbleBuzzEntity,
    logo: Icon,
    title: <>Bubble Buzz – Your New Favorite Free Bubble Shooter Online</>,
    description: (
      <>
        Looking for a <strong>free online bubble shooter game</strong> that’s fast, fun, and easy to learn? Meet{' '}
        <strong>Bubble Buzz</strong>—a thrilling game where anyone can join the action, no experience needed. It’s
        short, satisfying fun you can enjoy anytime. Download Bubble Buzz now and start popping bubbles like a pro!
      </>
    ),
  },
  swiper: [
    { image: Swiper1 },
    { image: Swiper2 },
    { image: Swiper3 },
    { image: Swiper4 },
    { image: Swiper5 },
    { image: Swiper6 },
    { image: Swiper7 },
  ],
  content: [
    {
      title: <>Fast-Paced Bubble Popping Fun—No Experience Needed</>,
      description: (
        <>
          Get ready to jump into exciting rounds of <strong>Bubble Buzz</strong>, the only{' '}
          <strong>free bubble shooter online</strong> with nonstop surprises! Each match is quick, colorful, and packed
          with satisfying pops—perfect for short bursts of fun during your day. Tap to aim, shoot bubbles to match three
          or more, and unleash power-ups like Rocket, Bomb, and Rainbow Bubble to clear the board. What makes{' '}
          <strong>Bubble Buzz</strong> stand out? Weekly <strong>in-game events</strong> and themed seasonal challenges
          that keep every session fresh and exciting. No steep learning curve—just pure, fast-paced fun that rewards
          your skills and keeps you coming back.
        </>
      ),
      image: Detail1,
    },
    {
      title: <>Compete Globally in This Skill-Based Real Money Game</>,
      description: (
        <>
          Think you’ve got quick reflexes and smart moves? In <strong>Bubble Buzz</strong>, your skills take center
          stage. Players will be matched with others of equal skill, and everyone competes with the same bubble board,
          making every match fair and focused on strategy. Each game is part of a multiplayer tournament, where
          outscoring your opponents requires precision, timing, and smart decisions. Level up while you play and explore
          higher-stakes matches, all with the opportunity to win real money. Every tap, shot, and combo counts—so bring
          your best game and embrace the competitive spirit that makes Bubble Buzz a total rush!
        </>
      ),
      image: Detail2,
    },
    {
      title: <>Easy, Secure, and Flexible Payment Options</>,
      description: (
        <>
          Winning is great—cashing out is even better. With <strong>Bubble Buzz</strong>, your winnings are safe and can
          be securely withdrawn through PayPal. Making a deposit is just as easy, with trusted options like PayPal,
          Venmo, Apple Pay, Visa, Mastercard, Amex, and Discover. Whether you&#39;re playing for fun or aiming for real
          rewards, <strong>Bubble Buzz</strong> ensures a smooth and secure experience from start to finish. No
          stress—just smooth payouts from your new favorite <strong>free bubble shooter online</strong>.
        </>
      ),
      image: Detail3,
    },
    {
      title: <>Ready to Pop Off? Discover Bubble Buzz and More in Avia!</>,
      description: (
        <>
          Whether you’ve got five minutes between errands or want to unwind after work, <strong>Bubble Buzz</strong> is
          your go-to for quick, exhilarating fun. Tap, pop, and win—anywhere, anytime. Discover even more exciting games
          from the <GamesLink>Aviagames</GamesLink> lineup! Whether you&#39;re sinking trick shots in{' '}
          <EightBallStrikeLink />, testing your speed and focus in <BingoClashLink />, or enjoying the classic charm of{' '}
          <SolitaireClashLink />, there’s something for everyone. Enjoy nonstop action, real rewards, and fun
          competition—anytime, anywhere!
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
} as TemplatePageProps
